import { useState, useMemo } from 'react';

export function useInvestmentFilters(investments) {
  const [searchQuery, setSearchQuery] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');
  const [sortField, setSortField] = useState('created_at');
  const [sortDirection, setSortDirection] = useState('desc');

  const uniqueTypes = useMemo(() => {
    return [...new Set(investments.map(inv => inv.type))];
  }, [investments]);

  const filteredInvestments = useMemo(() => {
    let filtered = investments;
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter(inv =>
        inv.name?.toLowerCase().includes(q) ||
        inv.type?.toLowerCase().replace(/_/g, ' ').includes(q) ||
        inv.currency?.toLowerCase().includes(q)
      );
    }
    if (typeFilter && typeFilter !== 'all') {
      filtered = filtered.filter(inv => inv.type === typeFilter);
    }
    filtered = [...filtered].sort((a, b) => {
      let aVal, bVal;
      switch (sortField) {
        case 'name': aVal = a.name || ''; bVal = b.name || ''; break;
        case 'amount': aVal = a.amount || 0; bVal = b.amount || 0; break;
        case 'current_value': aVal = a.current_value || a.amount || 0; bVal = b.current_value || b.amount || 0; break;
        case 'return': aVal = ((a.current_value || a.amount) - a.amount) / a.amount; bVal = ((b.current_value || b.amount) - b.amount) / b.amount; break;
        case 'created_at': aVal = new Date(a.created_at || 0); bVal = new Date(b.created_at || 0); break;
        default: return 0;
      }
      if (aVal < bVal) return sortDirection === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
    return filtered;
  }, [investments, searchQuery, typeFilter, sortField, sortDirection]);

  const toggleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };

  const clearFilters = () => { setSearchQuery(''); setTypeFilter('all'); };
  const hasFilters = searchQuery || (typeFilter && typeFilter !== 'all');

  return {
    searchQuery, setSearchQuery, typeFilter, setTypeFilter,
    sortField, sortDirection, uniqueTypes, filteredInvestments,
    toggleSort, clearFilters, hasFilters,
  };
}
